
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class CertificationReturnTaxDialog extends Common.GridEditorDialog<CertificationReturnTaxRow> {
        protected getFormKey() { return CertificationReturnTaxForm.formKey; }
        //protected getIdProperty() { return CertificationReturnTaxRow.idProperty; }
        protected getLocalTextPrefix() { return CertificationReturnTaxRow.localTextPrefix; }
        protected getNameProperty() { return CertificationReturnTaxRow.nameProperty; }
        //protected getService() { return CertificationReturnTaxService.baseUrl; }
        protected getDeletePermission() { return CertificationReturnTaxRow.deletePermission; }
        protected getInsertPermission() { return CertificationReturnTaxRow.insertPermission; }
        protected getUpdatePermission() { return CertificationReturnTaxRow.updatePermission; }

        protected form = new CertificationReturnTaxForm(this.idPrefix);

        constructor() {
            super();
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.TaxRate);
            q.setTextRightAlign(this.form.TaxAmount);
        }

    }
}